import { comercialDeck } from "@/decks/comercial/deck";
import { prospeccionDeck } from "@/decks/prospeccion/deck";
import { avanceDeck } from "@/decks/avance/deck";
import { cocaColaAndinaDeck } from "@/decks/coca-cola-andina/deck";
import { abastecimientoDeck } from "@/decks/abastecimiento/deck";
import type { Locale } from "@/i18n";
import type { DeckDef, SlideDef } from "@/decks/types";

const DECKS: DeckDef[] = [
  comercialDeck,
  prospeccionDeck,
  avanceDeck,
  cocaColaAndinaDeck,
  abastecimientoDeck,
];

export function getDeck(deckId: string): DeckDef | undefined {
  return DECKS.find((deck) => deck.id === deckId);
}

export function getVisibleSlides(deck: DeckDef): SlideDef[] {
  return deck.slides.filter((slide) => !slide.hidden);
}

export function getListedDeckIds(): string[] {
  return DECKS.filter((deck) => deck.listed).map((deck) => deck.id);
}

export function getAllDeckIds(): string[] {
  return DECKS.map((deck) => deck.id);
}

export interface DeckManifestEntry {
  id: string;
  listed: boolean;
  languages: Locale[];
}

// Metadata serializable de los decks listados. Base del manifest que consume la landing
// para enumerar decks por idioma. Los títulos/descripciones viven en messages/<locale>.json.
export function getDecksManifest(): DeckManifestEntry[] {
  return DECKS.filter((deck) => deck.listed).map((deck) => ({
    id: deck.id,
    listed: deck.listed,
    languages: deck.languages,
  }));
}
